module.exports = __webpack_public_path__ + "assets/img/beiligong.cdb2ed4e.png";